/*!
 * [Betbuilder Aggregator API] SignalR Module
 * Real-time aktualizácie MultiOdd kurzu cez SignalR
 */

betbuilderAgg.signalrModule = {

    // Aktuálna SignalR skupina
    _currentGroupName: null,

    /**
     * Vytvorenie SubOddsIDs reťazca (zoradené vzostupne, oddelené '|')
     * Príklad: "123456|234567|345678"
     * @returns {string|null} SubOddsIDs reťazec alebo null ak nie sú vybrané oddy
     */
    getSubOddsIDsString: function() {
        if (betbuilderAgg.state.selectedOdds.length === 0) {
            return null;
        }
        // Zoradiť oddy vzostupne a spojiť pomocou '|'
        return betbuilderAgg.state.selectedOdds
            .slice()
            .sort(function(a, b) { return a - b; })
            .join('|');
    },

    /**
     * Subscribe na SignalR skupinu pre MultiOdd aktualizácie
     * Skupina: "BBMULTIODD_{SubOddsIDs}"
     */
    subscribe: function() {
        try {
            // Kontrola či je SignalR dostupný a pripojený
            if (typeof connection === 'undefined' || 
                typeof signalR === 'undefined' || 
                connection.state !== signalR.HubConnectionState.Connected) {
                console.warn('[BetBuilder SignalR] Connection not available or not connected');
                return;
            }

            var subOddsIDs = betbuilderAgg.signalrModule.getSubOddsIDsString();
            if (!subOddsIDs) {
                return;
            }

            var groupName = 'BBMULTIODD_' + subOddsIDs;
            
            // Ak už sme subscribed na túto skupinu, skip
            if (betbuilderAgg.signalrModule._currentGroupName === groupName) {
                return;
            }

            // Unsubscribe z predchádzajúcej skupiny
            if (betbuilderAgg.signalrModule._currentGroupName) {
                betbuilderAgg.signalrModule.unsubscribe();
            }

            // Použiť ChangeView namiesto AddToGroup (ako ostatné skupiny)
            if (typeof events !== 'undefined' && events.eventsSignalrModule) {
                // Inicializovať offer.signalrView ak neexistuje
                if (!offer.signalrView) {
                    offer.signalrView = [];
                }
                
                // Pridať BetBuilder skupinu do signalrView
                var previousView = offer.signalrView.slice();
                
                // Odstrániť staré BBMULTIODD_ skupiny
                offer.signalrView = offer.signalrView.filter(function(view) {
                    return !view.startsWith('BBMULTIODD_');
                });
                
                // Pridať novú skupinu
                offer.signalrView.push(groupName);
                
                // Zavolať ChangeView
                events.eventsSignalrModule.changeViewSignalR(previousView)
                    .then(function() {
                        // Subscribe úspešný - nastaviť groupName pre filtrovanie správ
                        betbuilderAgg.signalrModule._currentGroupName = groupName;
                        betbuilderAgg.state.signalrGroupName = groupName;
                    })
                    .catch(function(err) {
                        console.error('[BetBuilder SignalR] Subscribe failed:', err.message);
                        // Rollback - vrátiť signalrView na pôvodný stav
                        offer.signalrView = previousView;
                        // Vyčistiť state ak bol nastavený
                        betbuilderAgg.signalrModule._currentGroupName = null;
                        betbuilderAgg.state.signalrGroupName = null;
                    });
            }

        } catch (error) {
            console.error('[BetBuilder SignalR] Error in subscribe:', error);
        }
    },

    /**
     * Unsubscribe zo SignalR skupiny
     */
    unsubscribe: function() {
        try {
            if (!betbuilderAgg.signalrModule._currentGroupName) {
                return;
            }
            
            var groupToRemove = betbuilderAgg.signalrModule._currentGroupName;
            
            // Použiť ChangeView namiesto RemoveFromGroup
            if (typeof events !== 'undefined' && events.eventsSignalrModule && offer.signalrView) {
                var previousView = offer.signalrView.slice();
                
                // Odstrániť BetBuilder skupinu zo signalrView
                offer.signalrView = offer.signalrView.filter(function(view) {
                    return view !== groupToRemove;
                });
                
                // Zavolať ChangeView
                events.eventsSignalrModule.changeViewSignalR(previousView)
                    .catch(function(err) {
                        console.error('[BetBuilder SignalR] Unsubscribe failed:', err.message);
                        // Rollback - vrátiť signalrView na pôvodný stav
                        offer.signalrView = previousView;
                    });
            }
            
            // Vyčistiť state aj v prípade chyby (lokálne odpojenie)
            betbuilderAgg.signalrModule._currentGroupName = null;
            betbuilderAgg.state.signalrGroupName = null;

        } catch (error) {
            console.error('[BetBuilder SignalR] Error in unsubscribe:', error);
        }
    },

    /**
     * Handler pre BbMultiOddChanged SignalR správu
     * @param {string} subOddsIDs - SubOddsIDs reťazec (oddy oddelené '|')
     * @param {number} oddsRate - Aktuálny kurz MultiOdd
     * @param {string} status - Status MultiOdd (napr. "Active", "Suspended", atď.)
     */
    handleBbMultiOddChanged: function(subOddsIDs, oddsRate, status) {
        try {
            // Overenie že správa patrí k aktuálne vybraným oddom
            var currentSubOddsIDs = betbuilderAgg.signalrModule.getSubOddsIDsString();
            
            if (currentSubOddsIDs !== subOddsIDs) {
                return; // Ignorovať správy pre iné oddy
            }

            // Aktualizovať celkový kurz
            if (oddsRate !== undefined && oddsRate !== null) {
                var parsedOddsRate = parseFloat(oddsRate);
                
                if (!isNaN(parsedOddsRate) && parsedOddsRate > 0) {
                    betbuilderAgg.state.totalOddsValue = parsedOddsRate;
                }
            }
            
            // Re-validovať dostupnosť a konflikty oddov
            if (betbuilderAgg.state.selectedOdds.length > 0) {
                // Nastaviť calculating flag pre ochranu
                betbuilderAgg.state.isCalculating = true;
                betbuilderAgg.calculateFilterOdds();
            }

            // Status handling
            if (status) {
                switch(status) {
                    case 'Suspended':
                        // MultiOdd je pozastavený - disable pridanie na tiket a zobraziť hlášku (po kliknuti na pridanie na tiket)
                        betbuilderAgg.state.isSuspended = true;
                        break;
                        
                    case 'Closed':
                        // Zatvoriť modal s výberom oddov
                        if (dialog.isOpen("betbuilder-agg__selected-odds-dialog")) {
                            dialog.close("betbuilder-agg__selected-odds-dialog");
                        }

                        // Zobraziť info že nie sú príležitosti
                        betbuilderAgg.state.showNoOpportunitiesMessage = true;
                        
                        // Zobraziť error modal
                        betbuilderAgg.state.errorMessage = betbuilderAgg.texts.BetBuilderAggClosedMessage;
                        
                        // Vyčistiť výber odložene aby sa stihla zobraziť hláška
                        setTimeout(function() {
                            // Prepnúť na default tab pred zobrazením hlášky
                            betbuilderAgg._switchToDefaultTab();
                            betbuilderAgg.destroy();
                        }, 500);
                        break;
                        
                    case 'Active':
                        // MultiOdd je aktívny - povoliť pridanie na tiket
                        if (betbuilderAgg.state.isSuspended) {
                            betbuilderAgg.state.isSuspended = false;
                        }
                        break;
                }
            }

        } catch (error) {
            console.error('[BetBuilder SignalR] Error in handleBbMultiOddChanged:', error);
        }
    },

    /**
     * Reset modulu - unsubscribe a vyčistenie stavu
     */
    reset: function() {
        betbuilderAgg.signalrModule.unsubscribe();
        betbuilderAgg.signalrModule._currentGroupName = null;
    }

};
